









































































































































































































import { JobDetailsModule } from "@/store/modules/jobDetails";
import { Component, Vue } from "vue-property-decorator";
import GiganautVue from "@/components/Shared/GiganautVue";
import { VuetifyConfirmObject } from "vuetify-confirm";
import JobGeneralDetailsEdit from '@/components/Jobs/JobGeneralDetailsEdit.vue';
import JobLocationDetailsEdit from '@/components/Jobs/JobLocationDetailsEdit.vue';
import JobStatus from "@/models/Jobs/JobStatus";

@Component({
  name: "JobDetails",
  components: { JobLocationDetailsEdit, JobGeneralDetailsEdit },
})
export default class extends GiganautVue {
  
  jobStatus = JobStatus;

  get job() {
    return JobDetailsModule.currentJob;
  }
}
